import fetch from "isomorphic-fetch";

export const API_ROOT = process.env.REACT_APP_API_ROOT;
//export const API_ROOT = 'http://local.foryourparty.com/'; //keep this here :)

// Fetches an API response and normalizes the result JSON according to schema.
// This makes every API response have the same shape, regardless of how nested it was.
export function callApi(
  endpoint,
  params = {},
  contentType = "json",
  apiRoot = API_ROOT
) {
  const fullUrl =
    endpoint.indexOf(apiRoot) === -1 ? apiRoot + endpoint : endpoint;

  params.mode = "cors";
  params.credentials = "include";
  params.method = params.method || "get";
  params.headers = params.headers || {};
  if (typeof params.headers["Content-Type"] === "undefined") {
    params.headers["Content-Type"] = "application/json";
  } else if (params.headers["Content-Type"] === null) {
    //in case we want the browser to set the content type, and don't want application/json used
    delete params.headers["Content-Type"];
  }

  if (params.need_csrf) {
    return getCSRFToken()
      .then((response) => {
        params.headers["X-CSRF-Token"] = response.response;
        return sendRequest(fullUrl, params, contentType);
      })
      .catch((error) => {
        alert("Error trying to get CSRF request");
        console.error(error);
      });
  } else {
    return sendRequest(fullUrl, params, contentType);
  }
}

function sendRequest(fullUrl, params, contentType) {
  return fetch(fullUrl, params)
    .then((response) => {
      if (!response.ok) {
        var error = contentType === "json" ? response.json() : response.text();
        return error.then((err) => {
          throw err;
        });
      }
      return contentType === "json" ? response.json() : response.text();
    })
    .then((response) => {
      return { response: response };
    })
    .catch((error) => {
      console.error(error);
      return { error: error };
    });
}

export function getCSRFToken() {
  const fullUrl = API_ROOT + "session/token";

  const params = {};
  params.mode = "cors";
  params.credentials = "include";
  params.method = params.method || "get";

  return fetch(fullUrl, params)
    .then((response) => {
      if (!response.ok) {
        return { error: response.statusText };
      }

      return response.text();
    })
    .then((response) => {
      return { response: response };
    })
    .catch((error) => {
      return { error: error };
    });
}
